const OPEN_STATUSES = [
  "paid",
  "fulfillment_requested",
  "shipped",
  "delivered",
];

export function findLatestSuppliesOrder(orders, productType) {
  if (!Array.isArray(orders) || !orders.length) return null;
  return (
    orders.find(
      (o) =>
        o?.productType === productType &&
        OPEN_STATUSES.includes(o?.status)
    ) || null
  );
}

export function formatSuppliesStatus(status) {
  switch (status) {
    case "paid":
      return "Payment received";
    case "fulfillment_requested":
      return "Being prepared";
    case "shipped":
      return "Shipped";
    case "delivered":
      return "Delivered";
    case "failed":
      return "Failed";
    case "refunded":
      return "Refunded";
    default:
      return status ? String(status).replace(/_/g, " ") : "Processing";
  }
}

export function trackingSearchUrl(trackingNumber, carrier) {
  if (!trackingNumber) return null;
  const q = [carrier, trackingNumber, "tracking"]
    .filter(Boolean)
    .join(" ")
    .trim();
  return `https://www.google.com/search?q=${encodeURIComponent(q)}`;
}

export function formatOrderDate(value) {
  if (!value) return null;
  try {
    return new Date(value).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return null;
  }
}
